import AccountingCashbookTab from "./AccountingCashbookTab";
import AccountingGeneralLedgerTab from "./AccountingGeneralLedgerTab";
import AccountingAnalyticsTab from "./AccountingAnalyticsTab";
import AccountingReconciliationsTab from "./AccountingReconciliationsTab";

export const ACCOUNTING_TABS = [
  { id: "cashbook", label: "Cashbook", component: AccountingCashbookTab },
  { id: "ledger", label: "General Ledger", component: AccountingGeneralLedgerTab },
  { id: "analytics", label: "Analytics", component: AccountingAnalyticsTab },
  { id: "reconciliations", label: "Reconciliations", component: AccountingReconciliationsTab },
];
